import React from "react";
import { colors, buttons, utils } from "../../styles/index";

export function Tabs({ value, onChange, children }) {
  return (
    <div>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child;
        return React.cloneElement(child, { value, onChange });
      })}
    </div>
  );
}

export function TabsList({ children, value, onChange }) {
  return (
    <div
      style={{
        display: "flex",
        gap: 8,
        borderBottom: `1px solid ${colors.border}`,
        paddingBottom: 8,
        marginBottom: 20,
        flexWrap: "wrap",
      }}
    >
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child;

        const tab = child.props["data-tab"];
        const active = tab === value;

        return React.cloneElement(child, {
          onClick: () => onChange(tab),
          style: {
            ...buttons.secondary,
            padding: "8px 14px",
            borderRadius: 8,
            fontWeight: active ? 600 : 500,
            background: active
              ? colors.primarySoft
              : "transparent",
            color: active
              ? colors.primary
              : colors.textMuted,
          },
        });
      })}
    </div>
  );
}
